import abi from './abi.json';
import { Network } from '../../providers/Networks/useNetworks';
import { IContractConfig } from '../types';

export const igoConfig: { [network in Network]: IContractConfig } = {
	[Network.MUMBAI_TESTNET]: {
		abi,
		address: '0xa455F248ba4475D11043D029d7dc6FD11270B66e',
	},
	[Network.POLYGON_MAINNET]: {
		abi,
		address: '0xa455F248ba4475D11043D029d7dc6FD11270B66e',
	},
};
